<template>
  <div>
    <table-manager :options="options" @ClickOnAddButton="showAdd"/>

    <basic-table
      :items="accountingPeriod"
      :fields="accountingPeriodFields"
      @RowSelected="accountingPeriodSelected"
      @ClickOnEditButton="onRowDoubleClick"/>
      <editModal :editItem="newAccountingPeriod"/>

      <modal-ok-cancel @save="selectAccoutingPeriod" @cancel="hideAccoutingPeriod" saveButtonLabel="Ok" size="lg"/>
  </div>
</template>

<script>
import editModal from '@/pages/tariffication/additional/accountingPeriods/editModal'
import moment from 'moment'

export default {
  components: {
    editModal
  },
  data () {
    return {
      selectedAccountingPeriod: null,
      newAccountingPeriod: null,
      accountingPeriodFields: [
        {key: 'static_id', label: 'ID', sortable: true},
        {key: 'id', label: this.$i18n.t('Serial ID'), sortable: true},
        {key: 'name', label: this.$i18n.t('Name'), sortable: true},
        {key: 'begin',
          label: this.$i18n.t('Start date'),
          sortable: true,
          formatter: (val, key, item) => {
            return this.$root.showDataWithTZDelta(val) + '   (' + this.msToDiffTime(this.$root.getMomentWithTZDelta(val)) + ')'
          }
        },
        {key: 'end',
          label: this.$i18n.t('End date'),
          sortable: true,
          formatter: (val, key, item) => {
            return this.$root.showDataWithTZDelta(val) + '   (' + this.msToDiffTime(this.$root.getMomentWithTZDelta(val)) + ')'
          }},
        {key: 'namePeriodicType', label: this.$i18n.t('Period type'), sortable: true}
      ],
      options: {
        isShowAddButton: true
      }
    }
  },
  methods: {
    onRowDoubleClick (item) {
      this.selectedAccountingPeriod = item
      this.selectAccoutingPeriod()
    },
    accountingPeriodSelected (row) {
      this.selectedAccountingPeriod = row
    },
    selectAccoutingPeriod () {
      if (!this.selectedAccountingPeriod) {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Select accounting period'), 'Error')
        return
      }
      this.$emit('input', this.selectedAccountingPeriod.id)
      this.$emit('hideAccoutingPeriod')
    },
    hideAccoutingPeriod () {
      this.$emit('hideAccoutingPeriod')
    },
    msToDiffTime (timestampMs) {
      let msDiff = timestampMs - new Date().getTime()

      let postfixSgn = '+'
      if (msDiff < 0) {
        postfixSgn = '-'
        msDiff = -msDiff
      }

      const daysDiff = Math.floor(msDiff / (24 * 60 * 60 * 1000))

      let postfixDays = ''
      if (daysDiff >= 1) {
        postfixDays = +String(daysDiff) + 'd, '
      }

      let s = postfixSgn + postfixDays + this.msToTime(msDiff)
      return s
    },
    msToTime (timestampMs) {
      if (timestampMs < 0) {
        timestampMs = -timestampMs
      }

      const timestampSec = (timestampMs / 1000) % (24 * 60 * 60)

      const seconds = timestampSec % 60
      const minutes = (timestampSec / 60) % 60
      const hours = (timestampSec / 60 / 60) % 24

      const hoursStr = String(hours | 0).padStart(2, '0')
      const minutesStr = String(minutes | 0).padStart(2, '0')
      const secondsStr = String(seconds | 0).padStart(2, '0')

      return `${hoursStr}:${minutesStr}:${secondsStr}`
    },
    showAdd () {
      this.newAccountingPeriod = {
        id: 0,
        start_time: moment().unix(),
        periodic_type: 1,
        custom_duration: 300,
        charge_interval: 1,
        invoice_month: 0,
        end: 0
      }
      this.$root.$emit('bv::show::modal', 'modalEditAccountingPeriod', '#btnShow')
    }
  },
  computed: {
    accountingPeriod () {
      let copy = JSON.parse(JSON.stringify(this.$store.getters['Tariffing/ACCOUNTING_PERIODS']))
      copy = copy.filter(function (value) {
        return value.static_id !== 0
      })
      for (let el of copy) {
        el.namePeriodicType = ''
        switch (el.periodic_type) {
          case 1:
            el.namePeriodicType = this.$i18n.t('Daily')
            break
          case 2:
            el.namePeriodicType = this.$i18n.t('Weekly')
            break
          case 3:
            el.namePeriodicType = this.$i18n.t('Monthly')
            break
          case 4:
            el.namePeriodicType = this.$i18n.t('Quarterly')
            break
          case 5:
            el.namePeriodicType = this.$i18n.t('Annual')
            break
          case 1048576:
            el.namePeriodicType = this.$i18n.t('Custom duration')
            break
        }
      }
      return copy
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/users/usersAndGroups/detail/serviceLinks/formAccountingPeriod.vue